module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/en-商业道德.c370c37c.png";